import { ActionType } from 'typesafe-actions';
import * as groupActionCreators from './actions';
import reducer from './reducer';

export default reducer;

export const actions = groupActionCreators;

export * from './types';
export type GroupsActions = ActionType<typeof groupActionCreators>;
